import { useEffect } from 'react';

import {
    cancelAnimation,
    useAnimatedStyle,
    useSharedValue,
    withDelay,
    withRepeat,
    withSequence,
    withTiming,
} from 'react-native-reanimated';

import { RailLoadingStatus } from 'screens/Modular/types';

function useStripeLoadingAnimation(loadingStatus: RailLoadingStatus) {
    const opacitySharedValue = useSharedValue(1);
    const animatedStyle = useAnimatedStyle(() => ({
        opacity: opacitySharedValue.value,
    }));

    useEffect(() => {
        if (
            loadingStatus === RailLoadingStatus.LOADING ||
            loadingStatus === RailLoadingStatus.IDLE
        ) {
            opacitySharedValue.value = withRepeat(
                withSequence(
                    withTiming(0.3, { duration: 600 }),
                    withDelay(100, withTiming(1, { duration: 600 })),
                ),
                100,
            );
        } else {
            cancelAnimation(opacitySharedValue);
            opacitySharedValue.value = 1;
        }
    }, [loadingStatus]);

    return { opacitySharedValue, animatedStyle };
}

export default useStripeLoadingAnimation;
